export default __webpack_public_path__ + "static/media/Untitled design (2).8f7b93ad.jpg";